import React, {useEffect, useState, Fragment, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';

const FinanceListing = ({
        history,
        businessListing,
        businessList = [],
        fetchZones,
        getFetchZones = null,
        // getListFilterData,
        filterDropdownList = [],
        getCampaignData,
        addCampaignData,
        getCampaignListing = [],
        createAdsCampaign = [],
        match
    }) => {
    const headers = [
        'Campaign Type',
        'Campaign Subtype',
        'Campaign Start Date',
        'Estimated Revenue',
        'Created By',
        'Created By Email',
        'Created At',
        'Status',
        'Action',
    ];
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [isStatusSuccess, setIsStatusSuccess] = useState(false);
    const [isRoleId, setIsRoleId] = useState(null);
    const {baseUrl} = useContext(BaseUrl);

    useEffect(() => {
        (async () => {
            const roles = await JSON.parse(localStorage.getItem('roles'));
            roles && setIsRoleId(roles[0].pivot.role_id);
        })();
    }, []);


    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getCampaignData(1, filterData)
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        const tableData = [
            'id',
            'campaign_type',
            'campaign_subtype',
            'start_date',
            'est_revenue',
            'name',
            'email',
            'created_at',
            'status_name',
        ];

        if (getCampaignListing.data) {
            const data = getCampaignListing.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})),
                    {
                        Action: [
                            {
                                name: 'View Details', 
                                link: `campaign-view`
                            }
                    ]
                        
                    }
                )
            );
            data && setListData(data);
            setPageCount(Math.ceil(getCampaignListing.total / getCampaignListing.per_page));
        }
    }, [getCampaignListing]);

    const applyFilter = async (filterData) => {
        localStorage.setItem("getCampaignListing", JSON.stringify(filterData));
        // console.log('filterData:',filterData);
        // return false;
        setIsLoading(true);
        setFilterData(filterData);
        await getCampaignData(1, filterData);
        setIsLoading(false);
        filterToggle();
    };

    // useEffect(() => {
    //     (async () => {
    //         await getListFilterData(2);
    //     })();
    // }, []);

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const headerBtns = () => {
        return (
            <Fragment>
                 {/* <Link
                    to={`${baseUrl}/campaign-creation`}
                    className="btn btn-primary"
                    >
                    {localization.addCampaign}
                </Link> */}
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                >
                    <img src={Images?.Filter} alt=""/>
                    {localization.showFilters}
                </Button>
            </Fragment>
        );
    };

    const onPageChange = async (val) => {
        let filter = filterData === null ? null : filterData;
        setIsLoading(true);
        await getCampaignData(val.selected + 1, filter);
        localStorage.setItem('page', val.selected + 1)
        setIsLoading(false);
    };

    const getZones = (val) => {
        if (val) fetchZones(val);
    };

    const closeSuccess = () => {
        setIsLoading(true);
        setIsStatusSuccess(!isStatusSuccess);
        setIsLoading(false);
    };

    return (
        <Layout
            title={localization.financeList}
            Buttons={headerBtns}
            isLoading={isLoading}
            isGoback
        >
            <TableSection
                data={listData}
                isId={false}
                headers={headers}
                detailList={getCampaignListing && getCampaignListing.data}
                pageCount={pageCount}
                srNo={getCampaignListing?.from}
                onPageChange={onPageChange}
                currentPage={localStorage.getItem('page')}
            />

            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                CampaignListFilter={true}
            />

            <ModalPop
                title={localization.updatedSuccessfully}
                show={isStatusSuccess}
                handleModalHide={closeSuccess}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt=""/>
                    </div>
                    <h5>{localization.leadStatusupdatedsuccessfully}</h5>
                    <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
                        {localization.continue}
                        <img src={Images?.ArrowRight} alt=""/>
                    </Link>
                </div>
            </ModalPop>
        </Layout>
    );
};

export default FinanceListing;
